import React from 'react';
import { Box } from '@chakra-ui/react';
import Header from '../components/Header.jsx';
import Hero from '../components/Hero.jsx';
import ServicesSection from '../components/ServicesSection.jsx';
import ContactSection from '../components/ContactSection.jsx';
import Footer from '../components/Footer.jsx';
import FlagBg2 from '../utils/images/036779AC-67D0-41FD-A111-A1A0ACAA434E.png';
import FlagBg3 from '../utils/images/702BCC4A-D639-4370-8702-72D19A2A2DD1.png';
import FlagBg4 from '../utils/images/image_backgroundRF.jpg';

const Home = () => {
  return (
    <Box
      minH="100vh"
      display="flex"
      flexDirection="column"
      bgImage={{ base: `url(${FlagBg3})`, md: `url(${FlagBg2})` }}
      bgPosition={{ base: 'center top', md: 'center' }}
      bgRepeat="no-repeat"
      bgSize={{ base: 'contain', md: 'cover' }}
      bgAttachment={{ base: 'scroll', md: 'fixed' }}
      position="relative"
      _before={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bg: 'rgba(0, 0, 0, 0.4)',
        zIndex: 0,
        pointerEvents: 'none'
      }}
    >
      <Header />
      <Box as="main" flex="1" pt={["100px", "100px", "90px", "90px"]} position="relative" zIndex={1}>
        <Hero />
        <ServicesSection />
        <ContactSection />
      </Box>
      <Footer />
    </Box>
  );
};

export default Home;